<template>
  <fichar></fichar>
</template>
<script>
import fichar from "@/components/fichajes/fichar";

export default {
  components: {
    fichar
  }
};
</script>
